import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lightbulb, Volume2 } from "lucide-react";
import { api } from "../api";
import { ASSETS } from "../assets";
import { gradeProfile } from "../gradeProfile";
import { useLang } from "../i18n";

export const MascotGuide = ({ grade, name }) => {
  const { t } = useLang();
  const [tip, setTip] = useState(null);
  const profile = gradeProfile(grade);

  useEffect(() => { api.get("/student/tip").then((r) => setTip(r.data)).catch(() => setTip(null)); }, []);

  const say = (txt) => {
    const u = new SpeechSynthesisUtterance(txt);
    u.lang = "en-US"; u.rate = 0.85;
    speechSynthesis.speak(u);
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="glass p-6 flex flex-col sm:flex-row items-center gap-6" data-testid="mascot-guide">
      <img src={ASSETS.mascot} alt="" className="w-28 sm:w-32 float-slow mix-blend-screen soft-mask" />
      <div className="flex-1 min-w-0">
        <div className="text-xs font-bold uppercase tracking-widest text-white/60">
          {profile.label.ar} · {t("grade")} {profile.grade} · {profile.book}
        </div>
        <h3 className="text-xl sm:text-2xl font-black text-white mt-1" data-testid="mascot-greeting">
          {tip?.greeting_ar || `مرحباً ${name || ""}! 👋`}
        </h3>
        {tip?.tip_ar && (
          <p className="text-white/75 text-sm mt-2 flex items-start gap-2" data-testid="mascot-tip">
            <Lightbulb size={16} className="mt-1 shrink-0" style={{ color: "#ffd166" }} />{tip.tip_ar}
          </p>
        )}
        {tip?.phrase_en && (
          <div className="glass-soft mt-4 px-4 py-3 flex items-center gap-3" data-testid="mascot-phrase">
            <button onClick={() => say(tip.phrase_en)} data-testid="mascot-say-btn"
              className="w-9 h-9 rounded-full grid place-items-center text-white shrink-0"
              style={{ background: profile.accent }}><Volume2 size={15} /></button>
            <div className="min-w-0">
              <div className="font-bold" dir="ltr">{tip.phrase_en}</div>
              {tip.phrase_ar && <div className="text-xs text-white/60">{tip.phrase_ar}</div>}
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};
